import _extends from "@babel/runtime/helpers/extends";
import React, { createContext } from 'react';
import { FlightDeckProvider } from '@atlassiansox/flight-deck-frontend-client';
import { usePeopleAndTeamsRemoteArtifact } from '../flight-deck';
import { DEFAULT_CONTEXT } from './constants';
import { usePeopleAndTeamsConfigurationOverrides } from './hooks/usePeopleAndTeamsConfigurationOverrides';
export const PeopleAndTeamsConfigurationContext = /*#__PURE__*/createContext(DEFAULT_CONTEXT);
export const PeopleAndTeamsBasicConfigurationProvider = ({
  children,
  locale,
  product,
  teamPermissions,
  orgId,
  teamPermissionCheckEnabled = false
}) => {
  const overrides = usePeopleAndTeamsConfigurationOverrides(teamPermissionCheckEnabled, orgId, teamPermissions);
  const artifact = usePeopleAndTeamsRemoteArtifact(product, locale, overrides);
  return /*#__PURE__*/React.createElement(PeopleAndTeamsConfigurationContext.Provider, {
    value: artifact || DEFAULT_CONTEXT
  }, children);
};
export const PeopleAndTeamsConfigurationProvider = ({
  children,
  locale,
  product,
  teamPermissions,
  teamPermissionCheckEnabled,
  orgId,
  ...flightDeckProps
}) => {
  return /*#__PURE__*/React.createElement(FlightDeckProvider, _extends({
    product: product
  }, flightDeckProps), /*#__PURE__*/React.createElement(PeopleAndTeamsBasicConfigurationProvider, {
    locale: locale,
    product: product,
    teamPermissions: teamPermissions,
    teamPermissionCheckEnabled: teamPermissionCheckEnabled,
    orgId: orgId
  }, children));
};
export const usePeopleAndTeamsConfigurationContext = () => React.useContext(PeopleAndTeamsConfigurationContext);